import { Facebook, Instagram } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { useState, useEffect } from 'react';

function FlashLine({ children }) {
  return (
    <motion.p
      className="font-heading text-base tracking-[0.15em] uppercase leading-relaxed font-bold"
      animate={{
        color: ['#E32510', '#ffffff', '#E32510'],
        textShadow: [
          '0 0 8px rgba(227,37,16,0.6), 0 0 16px rgba(227,37,16,0.3)',
          '0 0 8px rgba(255,255,255,0.6), 0 0 16px rgba(255,255,255,0.3)',
          '0 0 8px rgba(227,37,16,0.6), 0 0 16px rgba(227,37,16,0.3)',
        ],
      }}
      transition={{ duration: 2.5, repeat: Infinity, ease: 'easeInOut' }}
    >
      {children}
    </motion.p>
  );
}

export default function MessageWidget() {
  const { t } = useLanguage();
  const [mobileVisible, setMobileVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const nearBottom = window.innerHeight + window.scrollY >= document.body.scrollHeight - 300;
      setMobileVisible(nearBottom);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-14 right-4 sm:right-6 z-[9999] flex flex-col items-center gap-1 sm:gap-2 transition-opacity duration-300 ${mobileVisible ? 'opacity-100' : 'opacity-0 pointer-events-none sm:opacity-100 sm:pointer-events-auto'}`}
      data-testid="message-widget"
    >
      <div className="text-center">
        <FlashLine>{t('dontKnow')}</FlashLine>
        <FlashLine>{t('needHelp')}</FlashLine>
        <FlashLine>{t('messageUsNow')}</FlashLine>
      </div>
      <div className="flex items-center gap-2 sm:gap-3 bg-brand rounded-full pl-2 sm:pl-3 pr-3 sm:pr-5 py-2 sm:py-2.5 shadow-[0_0_25px_rgba(227,37,16,0.5),0_0_50px_rgba(227,37,16,0.25)] hover:shadow-[0_0_35px_rgba(227,37,16,0.7),0_0_70px_rgba(227,37,16,0.35)] transition-shadow cursor-pointer">
        <a href="https://www.instagram.com/okiescape/" target="_blank" rel="noopener noreferrer" data-testid="widget-instagram-btn" className="w-7 h-7 sm:w-9 sm:h-9 rounded-full bg-white flex items-center justify-center hover:scale-110 transition-transform"><Instagram size={14} className="text-brand sm:hidden" /><Instagram size={18} className="text-brand hidden sm:block" /></a>
        <a href="http://facebook.com/okiescape" target="_blank" rel="noopener noreferrer" data-testid="widget-facebook-btn" className="w-7 h-7 sm:w-9 sm:h-9 rounded-full bg-white flex items-center justify-center hover:scale-110 transition-transform"><Facebook size={14} className="text-brand sm:hidden" /><Facebook size={18} className="text-brand hidden sm:block" /></a>
        <span className="font-heading text-xs sm:text-sm tracking-widest uppercase text-white">{t('social')}</span>
      </div>
    </div>
  );
}
